module.exports = __webpack_public_path__ + "blissweb-rg.a104af609947bf5ea64f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Rg/blissweb-rg.ttf
// module id = 480
// module chunks = 5